import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import * as customizationUtils from 'customizer/customization/utils'

import LabelAnswer from '../answer/LabelAnswer'

import './LabelQuestion.scss'

export interface LabelQuestionProps {
  question: DenormalizedCustomizableQuestion
  pricing?: Record<string, string>
  currency: string
  lang?: string
  country?: string
  selectAnswer: (answerId?: string) => void
  focusQuestion: () => void
  answersOutOfStock: string[]
}

const LabelQuestion = ({
  question,
  pricing,
  currency,
  lang,
  country,
  answersOutOfStock,
  focusQuestion,
  selectAnswer,
}: LabelQuestionProps) => {
  const handleAnswerClick = (answerId: string) => {
    selectAnswer(answerId)
    focusQuestion()
  }

  const isDisabled = !!question.isMultiAnswer && customizationUtils.countSelectionsLeft(question) === 0

  return (
    <div className="label-question" data-testid="label-question">
      {question.answers.map(answer => {
        const isSelected = question.isMultiAnswer
          ? !!question.selectedAnswers?.find(selectedAnswer => selectedAnswer.id === answer.id)
          : answer.id === question.selectedAnswer?.id

        const isOutOfStock = answersOutOfStock.includes(answer.id)

        return (
          <div
            className="answer-container"
            onClick={() => (!isDisabled || isSelected) && handleAnswerClick(answer.id)}
            key={answer.id}
          >
            <LabelAnswer
              {...answer}
              selected={isSelected}
              id={answer.id}
              price={pricing?.[answer.id]}
              currency={currency}
              lang={lang}
              country={country}
              isMultiAnswer={question.isMultiAnswer}
              disabled={isDisabled && !isSelected}
              isOutOfStock={isOutOfStock}
              showRelativePrice={question.showRelativePrice}
            />
          </div>
        )
      })}
    </div>
  )
}

export default LabelQuestion
